import { useEffect } from "react";

function BackspaceButton({ onClick }) {
  useEffect(() => {
    const handleKeyPress = (event) => {
      if (event.key === "Backspace") {
        onClick();
      }
    };
    document.addEventListener("keydown", handleKeyPress);
    return () => {
      document.removeEventListener("keydown", handleKeyPress);
    };
  }, ["Backspace", onClick]);
  return <button onClick={() => onClick()} className="btn btn-block btn-danger">D</button>;
}

export default BackspaceButton;
